<script lang="ts">
  import Typography from "$lib/components/Typography/Typography.svelte";

  export let denominationOption: {
    value: string;
    inStock?: boolean;
    displayName?: string;
  };
  export let theme: string;
</script>

{#each denominationOption.displayName.split("/") as display, i}
  <Typography component="p" variant="caption1" {theme}
    >{i > 0 ? "/ " : ""}{display}</Typography
  >
{/each}
